import { useContext } from 'react';
import { MapContext } from '../../contexts/map';
import { useDrawWorksitesOnMap } from './effects';

const Worksite = function ({ worksite, events, hideWorksiteTooltip }) {
  const { map } = useContext(MapContext);
  useDrawWorksitesOnMap(map, worksite, events, hideWorksiteTooltip);
  return null;
};

const Worksites = function ({ worksites, events, hideWorksiteTooltip }) {
  return (
    <>
      {(worksites || []).map((w) => (
        <Worksite
          key={`map-worksite-${w.device_session_id}-${w.cluster_id}`}
          worksite={w}
          events={events}
          hideWorksiteTooltip={hideWorksiteTooltip}
        />
      ))}
    </>
  );
};

export default Worksites;
